import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { layout, flexbox, space } from 'styled-system';
import { StyledProps } from 'types/styles';
import { BaseText, H1 } from 'styles/__typography';

interface Props extends StyledProps {}

export const FormWrapper = styled.div<Props>`
  display: flex;
  width: 100%;
  max-width: 520px;
  background-color: white;
  padding: 32px 24px;
  border-radius: 16px;
  border: 1px solid ${themeGet('colors.glassDark.2')};
`;

export const Form = styled.div<Props>`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const FormHeader = styled(H1)<Props>``;

FormHeader.defaultProps = {
  fontSize: 8,
  fontWeight: 1,
  mb: 4,
  color: 'text.secondary',
};

export const FormSubheader = styled(BaseText)<Props>``;

FormSubheader.defaultProps = {
  fontSize: 4,
  fontWeight: 1,
  color: 'text.secondary',
  mb: 8,
};

export const FormButtonContainer = styled.div<Props>`  
  ${layout}
  ${flexbox}
  ${space}
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

FormButtonContainer.defaultProps = {
  justifyContent: 'flex-end',
};
